import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User dismissed the version-target bar that offers returning to the asset they opened the canvas from.',
  name: 'canvas_back_to_asset_dismissed',
  params: [
    {
      description: 'The id of the canvas, omitted while the canvas is still an unsaved draft',
      name: 'canvas_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
